import styled from 'styled-components';
import { Grid } from '@material-ui/core';

const GridContainer = styled(Grid)`
  border-top: 1px solid rgba(0, 0, 0, 0.24);
`;

export default GridContainer;
